import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		pzHeadData: [{
				title: "凭证数据",
				children: [
					{
						title: "公司编号",
						prop: "companyCode",
						width: "200"
					},
					{
						title: "业务类型",
						prop: "businessTypeName",
						width: "200"
					},
					{
						title: "科目代码",
						prop: "subjectCode",
						width: "200"
					},
					{
						title: "凭证号",
						prop: "voucherNo",
						width: "200"
					},
					{
						title: "记账日期",
						prop: "jizrq",
						width: "200"
					},
					{
						title: "税率",
						prop: "shuil",
						width: "200"
					},
					{
						title: "记账金额",
						prop: "jizje",
						width: "200"
					},
					{
						title: "Billing号",
						prop: "billingNo",
						width: "200"
					},
					{
						title: "凭证摘要",
						prop: "voucherRemark",
						width: "200"
					}
				]
			},
			{
				title: "发票数据",
				children: [
					{
						title: "发票号码",
						prop: "faphm",
						width: "200"
					},
					{
						title: "开票日期",
						prop: "kaiprq",
						width: "200"
					},
					{
						title: "开票金额",
						prop: "jine",
						width: "200"
					},
					{
						title: "开票税额",
						prop: "shuie",
						width: "200"
					},
					{
						title: "操作",
						prop: "cz",
						width: "200",
						custom: true
					}
				]
			},
			{
				title: "处理状态",
				children: [
					{
						title: "税额差异",
						prop: "taxDiff",
						width: "200"
					},
					{
						title: "处理状态",
						prop: "status",
						width: "200",
						custom: true
					},
					{
						title: "Remark",
						prop: "remark",
						width: "200",
						custom:true
					}
				]
			}
		],
		fapHeadData: [
			{
				title: "发票数据",
				children: [
					{
						title: "公司编号4",
						prop: "companyCode",
						width: "200"
					},
					{
						title: "发票号码",
						prop: "faphm",
						width: "200"
					},
					{
						title: "开票日期",
						prop: "kaiprq",
						width: "200"
					},
					{
						title: "开票金额",
						prop: "jine",
						width: "200"
					},
					{
						title: "开票税额",
						prop: "shuie",
						width: "200"
					},
					{
						title: "操作",
						prop: "cz",
						width: "200",
						custom: true
					}
				]
			},
			{
			title: "凭证数据",
			children: [
				{
					title: "业务类型",
					prop: "businessTypeName",
					width: "200"
				},
				{
					title: "科目代码",
					prop: "subjectCode",
					width: "200"
				},
				{
					title: "凭证号",
					prop: "voucherNo",
					width: "200"
				},
				{
					title: "记账日期",
					prop: "jizrq",
					width: "200"
				},
				{
					title: "税率",
					prop: "shuil",
					width: "200"
				},
				{
					title: "记账金额",
					prop: "jizje",
					width: "200"
				},
				{
					title: "Billing号",
					prop: "billingNo",
					width: "200"
				},
				{
					title: "凭证摘要",
					prop: "voucherRemark",
					width: "200"
				}
			]
		},
			{
				title: "处理状态",
				children: [
					{
						title: "税额差异",
						prop: "taxDiff",
						width: "200"
					},
					{
						title: "处理状态",
						prop: "status",
						width: "200",
						custom:true
					},
					{
						title: "Remark",
						prop: "remark",
						width: "200",
						custom:true
					}
				]
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		nsrsbhData: [{
			nsrsbh: "",
			nsrmc: ""
		}]
	}
	return obj
}
